var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2689 1C33.6612 1 34.7899 2.1193 34.7899 3.5V33.5C34.7899 34.8807 33.6612 36 32.2689 36C30.8766 36 29.7479 34.8807 29.7479 33.5V3.5C29.7479 2.1193 30.8766 1 32.2689 1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9495 15C55.3418 15 56.4705 16.1193 56.4705 17.5V33C56.4705 34.3807 55.3418 35.5 53.9495 35.5C52.5572 35.5 51.4285 34.3807 51.4285 33V17.5C51.4285 16.1193 52.5572 15 53.9495 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8571 15C44.2494 15 45.3781 16.1193 45.3781 17.5V33C45.3781 34.3807 44.2494 35.5 42.8571 35.5C41.4648 35.5 40.3361 34.3807 40.3361 33V17.5C40.3361 16.1193 41.4648 15 42.8571 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6806 15C23.0729 15 24.2016 16.1193 24.2016 17.5V33C24.2016 34.3807 23.0729 35.5 21.6806 35.5C20.2883 35.5 19.1596 34.3807 19.1596 33V17.5C19.1596 16.1193 20.2883 15 21.6806 15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9977 1.8178C32.3777 2.2215 32.3557 2.8543 31.9485 3.2312L1.69646 31.2312C1.28932 31.608 0.651209 31.5862 0.271213 31.1824C-0.108794 30.7787 -0.0867904 30.1459 0.320362 29.769L30.7563 1.5001C31.1634 1.1233 31.6176 1.414 31.9977 1.8178Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6898 15.8302C54.0629 16.2403 54.0302 16.8726 53.6167 17.2426L33.7815 35.5002C33.368 35.8702 31.8933 36.0802 31.5202 35.6702C31.1471 35.2602 31.1798 34.6278 31.5932 34.2578L52.4369 15.5002C52.8504 15.1302 53.3167 15.4202 53.6898 15.8302Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5982 15.8309C42.9707 16.2414 42.9373 16.8737 42.5233 17.2432L23.1933 34.9999C22.7793 35.3694 21.3037 35.5794 20.9311 35.1689C20.5585 34.7584 20.5921 34.1261 21.006 33.7566L41.3445 15.4999C41.7584 15.1304 42.2256 15.4204 42.5982 15.8309Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3853 15.793C21.7791 16.1835 21.7791 16.8167 21.3853 17.2072L18.3601 20.2072C17.9663 20.5977 17.3278 20.5977 16.934 20.2072C16.5402 19.8167 16.5402 19.1835 16.934 18.793L19.6639 16.0001C20.0576 15.6096 20.9915 15.4025 21.3853 15.793Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.779 29.8754C60.1269 30.3067 60.0564 30.936 59.6215 31.281L55.4621 35.0001C55.0272 35.3451 53.51 35.5561 53.1621 35.1248C52.8142 34.6935 52.8847 34.0642 53.3196 33.7192L58.3616 29.7192C58.7965 29.3742 59.4311 29.4441 59.779 29.8754Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6866 29.8754C49.0345 30.3067 48.964 30.936 48.5291 31.281L44.3697 35.0001C43.9348 35.3451 42.4175 35.5561 42.0696 35.1248C41.7217 34.6935 41.7922 34.0642 42.2272 33.7192L47.2692 29.7192C47.7041 29.3742 48.3387 29.4441 48.6866 29.8754Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3529 1C43.5294 2.5 45.1764 6.4 42.3529 10",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8907 1C48.0672 2.5 49.7142 6.4 46.8907 10",
    stroke: "white",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9243 1C52.1008 2.5 53.7478 6.4 50.9243 10",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/Logo-white.7676de443fb9a2d6c215211a6f7b2913.svg";
export { ForwardRef as ReactComponent };